import LanguageApiUtils from '../utils/api/language';

export const FETCH_LANGUAGES_SENT = 'FETCH_LANGUAGES_SENT';
export const FETCH_LANGUAGES_SUCCEEDED = 'FETCH_LANGUAGES_SUCCEEDED';
export const FETCH_LANGUAGES_FAILED = 'FETCH_LANGUAGES_FAILED';

export function fetchSent() {
  return {
    type: FETCH_LANGUAGES_SENT,
  };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_LANGUAGES_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return {
    type: FETCH_LANGUAGES_FAILED,
  };
}

export function fetch() {
  return (dispatch) => {
    dispatch(fetchSent());
    return LanguageApiUtils.fetch().then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}
